import React from 'react'
import { Link } from 'react-router-dom'

function Account() {
  return (
    <div>
    
    <div className="breadcrumb-row">
            <div className="container">
                <div className="row">
                    <div className="col-md-12">
                        <div className="d-flex justify-content-between align-items-center breadcrumb-item">
                            <div className="breadcrumb-title-heading">
                                <h1 className="title">Account</h1>
                            </div>
                            <div className="breadcrumb-wrapper">
                                <span className="mr-1"><i className="ti ti-home"></i></span>
                                <Link title="Homepage" to="/">Home</Link>
                                <span className="ttm-bread-sep">&nbsp;/&nbsp;</span>
                                <span className="ttm-textcolor-skincolor">Acoount</span>
                            </div>
                        </div>
                    </div>
                </div>  
            </div>                    
        </div>
    {/* <!-- Section Start --> */}
    <section className="user_account">
        <div className="container-fluid">
            <div className="row">
                <div className="col-xl-3 col-lg-4">
                    <div className="account_sidebar section pb-0 h-100">
                        <ul>
                            <li className="active">
                                <Link to="/account">
                                    <i className="fal fa-user"></i>
                                    User Info
                                </Link>
                            </li>
                            <li>
                                <Link to="/account">
                                    <i className="fal fa-book"></i>
                                    Address
                                </Link>
                            </li>
                            <li>
                                <Link to="/order">
                                    <i className="fal fa-luggage-cart"></i>
                                    Order
                                </Link>
                            </li>
                            <li>
                                <Link to="/wishlist">
                                    <i className="fal fa-heart"></i>
                                    Favorites
                                </Link>
                            </li>
                            <li>
                                <Link to="/wishlist">
                                    <i className="fal fa-star"></i>
                                    Wishlist
                                </Link>
                            </li>
                            <li>
                                <Link to="#">
                                    <i className="fal fa-cog"></i>
                                    Settings
                                </Link>
                            </li>
                            <li>
                                <Link to="#">
                                    <i className="fal fa-bell"></i>
                                    Notifications
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="col-xl-9 col-lg-8">
                    <div className="section">
                        <div className="user_info_box">
                            <div className="user_box">
                                <div className="image">
                                    <img src="/tm/react/toolways/assets/images/user.jpg" className="image-fit" alt="img"/>
                                    <Link to="#" className="edit">
                                        <i className="fal fa-pencil"></i>
                                    </Link>
                                </div>
                                <div className="user_text">
                                    <h6 className="name mb-0">Jhon Deo</h6>
                                    <p className="mb-0">New York, USA</p>
                                </div>
                            </div>
                            {/* <!-- Form --> */}
                            <form action="#" method="POST" className="user_form">
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>First Name</label>
                                            <input type="text" name="#" className="form-control form-control-custom" placeholder="First Name" autoComplete="off" required/>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Last Name</label>
                                            <input type="text" name="#" className="form-control form-control-custom" placeholder="Last Name" autoComplete="off" required/>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Email Address</label>
                                            <input type="email" name="#" className="form-control form-control-custom" placeholder="Email I'd" autoComplete="off" required/>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Phone No.</label>
                                            <input type="text" name="#" className="form-control form-control-custom" placeholder="Phone No." autoComplete="off" required/>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Location</label>
                                            <input type="text" name="#" className="form-control form-control-custom" placeholder="Location" autoComplete="off" required/>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Postal/Zip Code</label>
                                            <input type="text" name="#" className="form-control form-control-custom" placeholder="Postal/Zip Code" autoComplete="off" required/>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <label className="mb-0">Linked Accounts</label>
                                        <p className="mb-3">Lorem Ipsum is simply dummy text of the printing</p>
                                        <div className="connect_social">
                                            <button type="button" className="social_btn mb-xl-30">
                                                <img src="/tm/react/toolways/assets/images/google.png" className="image-fit-contain" alt="img"/>
                                                Sign in With Google
                                            </button>
                                            <button type="button" className="thm-btn btn-rectangle thm-bg-color-one lh-normal mb-xl-30">Connect</button>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="connect_social">
                                            <div className="text">
                                                <label className="mb-0">Delete Account</label>
                                                <p>Lorem Ipsum is simply dummy text of the printing</p>
                                            </div>
                                            <Link to="#" className="simple_btn mb-xl-30">Delete Account...</Link>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <button type="submit" className="thm-btn btn-rectangle thm-bg-color-three">Save Changes</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    </div>
  )
}

export default Account